// src/pages/Users/Produits/components/DonationCard.jsx

import React from "react";
import {
  FaCloud,
  FaHeart,
  FaLock,
  FaTools,
  FaRocket,
} from "react-icons/fa";

export default function DonationCard({ donationUrl, variant = "full" }) {
  const compact = variant === "compact";

  return (
    <section
      aria-label="Soutenir le développement"
      className={`relative overflow-hidden rounded-[2rem] border border-pink-200 bg-white shadow-sm dark:border-pink-900/40 dark:bg-slate-900 ${
        compact ? "p-5" : "p-5 sm:p-6"
      }`}
    >
      <div className="pointer-events-none absolute -right-16 -top-16 h-36 w-36 rounded-full bg-pink-400/20 blur-3xl" />
      <div className="pointer-events-none absolute -bottom-16 -left-16 h-36 w-36 rounded-full bg-violet-400/20 blur-3xl" />

      <div className="relative">
        <div className="flex items-start gap-3">
          <div className="flex h-13 w-13 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-pink-500 to-violet-500 text-white shadow-lg shadow-pink-500/20">
            <FaHeart className="text-xl" />
          </div>

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-pink-500">
              Soutien volontaire
            </p>

            <h3 className="mt-1 text-2xl font-bold text-slate-950 dark:text-white">
              Aidez-moi à poursuivre le développement
            </h3>

            <p className="mt-2 text-sm leading-6 text-slate-600 dark:text-slate-300">
              Ces applications demandent beaucoup de temps : maintenance,
              hébergement, corrections, évolutions et création de nouveaux
              outils pour les clubs. Chaque don, même symbolique, m’aide à
              continuer.
            </p>
          </div>
        </div>

        {!compact && (
          <div className="mt-5 grid gap-3 sm:grid-cols-3">
            <DonationPoint
              icon={FaTools}
              title="Maintenance"
              text="Corrections, améliorations et nouvelles fonctionnalités."
            />
            <DonationPoint
              icon={FaRocket}
              title="Nouveaux projets"
              text="Création d’outils utiles aux clubs et aux enseignants."
            />
            <DonationPoint
              icon={FaCloud}
              title="Hébergement"
              text="Serveurs, stockage, sécurité et services techniques."
            />
          </div>
        )}

        <div className="mt-5 rounded-[1.5rem] bg-gradient-to-r from-slate-950 via-violet-950 to-pink-900 p-4 text-white">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p className="text-sm font-bold">
                Don unique de 5 € via Stripe
              </p>
              <p className="mt-1 text-xs text-white/70">
                100% facultatif · paiement sécurisé · merci pour votre soutien 🙏
              </p>
            </div>

            <a
              href={donationUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-12 shrink-0 items-center justify-center gap-2 rounded-2xl bg-white px-5 text-sm font-bold text-slate-950 shadow-lg transition hover:-translate-y-0.5 hover:bg-slate-100 active:translate-y-0"
            >
              <FaHeart className="text-pink-500" />
              Faire un don de 5 €
            </a>
          </div>
        </div>

        <p className="mt-3 flex items-center gap-2 text-[11px] text-slate-500 dark:text-slate-400">
          <FaLock />
          Don volontaire, sans obligation, sécurisé via Stripe.
        </p>
      </div>
    </section>
  );
}

function DonationPoint({ icon: Icon, title, text }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950">
      <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-slate-900 shadow-sm dark:bg-slate-900 dark:text-white">
        <Icon />
      </div>

      <h4 className="mt-3 text-sm font-bold text-slate-950 dark:text-white">
        {title}
      </h4>

      <p className="mt-1 text-xs leading-5 text-slate-500 dark:text-slate-400">
        {text}
      </p>
    </div>
  );
}